module.exports = __webpack_public_path__ + "static/img/Rectangle 54.a00ef151.png";